// product description script

document.addEventListener('DOMContentLoaded', () => {
  const descriptionWrappers = document.querySelectorAll('.hz__productMain__description');
  descriptionWrappers.forEach(content => {
    const description = content.querySelector('.product__description');
    const moreBtn = content.querySelector('.hz__pdpProduct_descriptionBtn_more');
    const lessBtn = content.querySelector('.hz__pdpProduct_descriptionBtn_less');

    if (!description || !moreBtn || !lessBtn) {
      console.warn('Required elements not found in one of the descriptions.');
      return;
    }
    const [originalHeight, initialHeight] = calculateHeights(description);
    
    if (originalHeight < 300) {
      description.style.maxHeight = 'none';
      moreBtn.style.display = 'none';
      lessBtn.style.display = 'none';
    } else {
      description.style.maxHeight = `${initialHeight}px`;
      lessBtn.style.display = 'none';

      moreBtn.addEventListener('click', () => {
        description.style.maxHeight = `${originalHeight}px`; 
        moreBtn.style.display = 'none'; 
        lessBtn.style.display = 'block'; 
      });

      lessBtn.addEventListener('click', () => {
        description.style.maxHeight = `${initialHeight}px`; 
        lessBtn.style.display = 'none';
        moreBtn.style.display = 'block'; 
      });
    }
  });
  
  function calculateHeights(description) {
    const children = description.children;
    let initialHeight = 0;
    for (let i = 0; i < 3 && i < children.length; i++) {
      initialHeight += children[i].offsetHeight;
    }

    const originalHeight = description.scrollHeight;

    return [originalHeight, initialHeight];
  }
});





document.addEventListener('DOMContentLoaded', () => {
    const faqs = document.querySelectorAll('.hz__pdpProductMain_collapsible');

    faqs.forEach((accordion) => {
      const title = accordion.querySelector('.hz__pdpPmColl_header');
      const content = accordion.querySelector('.hz__pdpPmColl_content');

      title.addEventListener('click', () => {
        const isActive = accordion.classList.contains('active');
        
        // Close all other accordions
        faqs.forEach((otherAccordion) => {
          if (otherAccordion !== accordion) {
            otherAccordion.classList.remove('active');
            otherAccordion.querySelector('.hz__pdpPmColl_content').style.maxHeight = '0';
          }
        });

        // Toggle the clicked accordion
        if (isActive) {
          accordion.classList.remove('active');
          content.style.maxHeight = '0';
        } else {
          accordion.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 35 + 'px';
        }
      });

      // Initialize the first accordion as active
      // if (accordion === faqs[0]) {
      //   accordion.classList.add('active');
      //   content.style.maxHeight = content.scrollHeight + 35 + 'px';
      // }
    });
  });